// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QH_t","label":"styles_label__3BK2c"};